import React from 'react';
import MessageCell from '@/components/table/MessageCell';

const VocabularyRoleActionsCell = ({ vocabulary }) => (
  <MessageCell
    className="td-description"
    messageId="items.count"
    messageArgs={{ count: vocabulary.roleActions.length }}
  />
);

export default VocabularyRoleActionsCell;
